import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'viewMore',
    standalone: false
})
export class ViewMorePipe implements PipeTransform {

  transform(value: string, maxLength: number = 50): {textResult: string, count: number} {
    if (!value) return {textResult:'',count:0};
    let classifications = value.split(',');
    let result = [];
    let truncatedCount = 0;

    for (let i = 0; i < classifications.length; i++) {
      if (result.join(', ').length + classifications[i].length + (result.length > 0 ? 2 : 0) <= maxLength) {
        result.push(classifications[i]);
      } else {
        truncatedCount++;
      }
    }

    let displayText = result.join(', ');

    if (truncatedCount > 0) {
     return { textResult:displayText , count:truncatedCount};
    }
    return { textResult:displayText , count:0};
  }
}
